import jQuery from 'jquery';
let $ = jQuery;

import "./Widget.js";

// define EVENTs
import "HSNDIR/Application.js";
// Desktop/Mobile split... Use Globally available HSN.BuySelector
//import "HSNDIR/BuySelector.js";

HSN.Widget.Favorite = function (config) {
    this.application = config.application;
    this.container = $(config.container);
    this.favoriteButton = $('.favorite-link', this.container);
    this.objectId = this.favoriteButton.data('object-id');
    this.objectType = this.favoriteButton.data('object-type');
    this.cmPrefix = this.favoriteButton.data('cmprefix');
    this.dataLayerUdo = this.favoriteButton.data('datalayer-udo');

    this.init();
};

HSN.Widget.Favorite.prototype = function () {
    function handleFavoritingEvents() {
        this.application.Events.On(HSN.Application.EVENT.FAVORITE_FAVORITED, function (type, id, variantId) {
            if (type !== this.objectType || id !== this.objectId) {
                return;
            }
            
            this.application._getFavoriteService().UpdateFavoriteLink(this.favoriteButton);
        }, this);

        this.application.Events.On(HSN.Application.EVENT.FAVORITE_UNFAVORITED, function (type, id, variantId) {
            if (type !== this.objectType || id !== this.objectId) {
                return;
            }

            this.application._getFavoriteService().UpdateFavoriteLink(this.favoriteButton);
        }, this);
    }

    function toggleFavorite(isFavorite, variantId) {
        HSN.DataLayer.helpers.favorite(this.dataLayerUdo, this.cmPrefix, this.objectType, this.objectId, isFavorite ? 0 : 1);

        this.application[isFavorite ? 'Unfavorite' : 'Favorite'](this.objectType, this.objectId, variantId);
    }
        
    function init() {
        if (!Modernizr.touchevents) {
            HSN.Tooltip(this.favoriteButton);
        }

        this.favoriteButton.on('click mouseup', { that: this }, function (e) {
            if (e.type == 'mouseup') {
                $(this).blur();
                return false;
            }
            var isFavorite = $(this).is('.favorited');
            var variantId = $(this).data('web-id');

            toggleFavorite.call(e.data.that, isFavorite, variantId);
            return false;
        });

        this.favoriteButton.on('touchstart mouseenter', function() {
            $(this).addClass('hover');
        });

        this.favoriteButton.on('mouseleave click', function () {
            $(this).removeClass('hover');
        });

        this.favoriteButton.on('touchmove', function () {
            var that = this;
            setTimeout(function () {
                $(that).removeClass('hover');
            }, 250);
        });

        this.application.Events.On(HSN.BuySelector.EVENT.VARIANT_SELECTED, function (variantId) {
            //TODO make this work
            //this.favoriteButton.data('web-id', variantId);
            //this.favoriteButton.attr('data-web-id', variantId);

            //this.application._getFavoriteService().UpdateFavoriteLink(this.favoriteButton);
        });
        
        handleFavoritingEvents.call(this);         
    }

    function destroy() {
        if (this.favoriteButton) {
            this.favoriteButton.off();
        }

        if (this.application) {
            this.application.Events.Off(HSN.Application.EVENT.FAVORITE_UNFAVORITED, null, this);
            this.application.Events.Off(HSN.Application.EVENT.FAVORITE_FAVORITED, null, this);
        }

        this.application = this.container = this.favoriteButton = this.dataLayerUdo = this.objectId = this.objectType = null;
    }

    return {
        init: init,
        destroy: destroy
    };
}();




// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/Favorite.js